<div class="flex flex-col gap-4">

  <!-- General Informations -->
  <div class="flex justify-between">
    <elcia-label label="{{'app.informations' | translate}}"/>
    <div class="flex items-center gap-4">
      @if (canAnalyse()) {
        <elcia-ai-button (onClick)="isAnalysisDisplayed.set(true)"
                         [label]="'ai.analyse' | translate"/>
      }
      <elcia-toggle-switch [control]="form().controls.isActive"
                           [label]="'customer.is-active' | translate"/>
    </div>
  </div>
  <div class="flex flex-col gap-4">

    <div class="flex gap-4">

      <div class="w-1/4">
        <elcia-text-input [control]="form().controls.name" [label]="'customer.name' | translate"
                          data-testid="company-name-input"/>
      </div>

      <div class="w-1/4">
        <elcia-legal-entity-dropdown [control]="form().controls.legalEntityAssignedId"/>
      </div>

      <div class="w-1/4">
        <elcia-local-dropdown [control]="form().controls.localeIsoCode"/>
      </div>
      <div class="w-1/4">
        <elcia-text-input [control]="form().controls.email" [label]="'customer.email' | translate"/>
      </div>
    </div>

    <div class="flex gap-4">

      <div class="w-3/4">
        <elcia-party-dropdown [control]="form().controls.contactIds" [isMulti]="true"
                              [label]="'entity.contacts' | translate"
                              [partyTypes]="contactPartyTypes"/>
      </div>
      <div class="w-1/4">
        <elcia-text-input [control]="form().controls.website" [label]="'customer.website' | translate"/>

      </div>
    </div>
  </div>

  <!-- Finance -->
  <div class="flex flex-col gap-4">
    <elcia-label [label]="'customer.finance' | translate"/>
    <div class="flex gap-4">
      <div class="w-1/3">
        <elcia-text-input [control]="form().controls.vatNumber" [label]="'customer.vat-number' | translate"/>
      </div>
      <div class="w-1/3">
        <elcia-text-input [control]="form().controls.accountingAccountName"
                          [label]="'customer.accounting-account-name' | translate"
                          data-testid="company-accounting-account-input"/>
      </div>

      <div class="w-1/3">
        <elcia-payment-mode-dropdown (methodChange)="onPaymentMethodChange($event)"
                                     [control]="form().controls.paymentModeId"/>
      </div>
    </div>
    <!-- Direct Debit Mandate -->
    @if (isDirectDebit()) {
      <div [animate.enter]="'slide-in-top'" class="flex flex-col gap-4">
        <elcia-direct-debit-form [control]="form().controls.directDebitForm"/>
      </div>
    }
  </div>

  <!-- Addresses -->
  <div class="flex flex-col gap-4">
    <!-- Is Same Billing Address -->
    <div class="flex justify-between">
      <elcia-label [label]="'address.address' | translate"/>
      <elcia-toggle-switch [control]="form().controls.isSameAddressForBilling"
                           [label]="'address.same-as-billing-address' | translate"/>
    </div>
    <!-- Address Form -->
    <elcia-address-form [control]="form().controls.addressForm"/>
    <!-- Billing Address Form -->
    @if (!form().controls.isSameAddressForBilling.value) {
      <div [animate.enter]="'slide-in-top'" class=" flex flex-col gap-4">
        <elcia-label [label]="'address.billing-address' | translate"/>
        <elcia-address-form [control]="form().controls.billingAddressForm"/>
      </div>
    }
  </div>

  <!-- Note -->
  <div class="flex flex-col gap-4">
    <elcia-label [label]="'customer.notes' | translate"/>
    <elcia-editor [control]="form().controls.note" [styles]="{ height: '200px' }"/>
  </div>

</div>

@if (isAnalysisDisplayed()) {
  <elcia-customer-analysis-dialog (onClose)="isAnalysisDisplayed.set(false)"
                                  [customerId]="customerId()!"/>
}
